var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'h-inlineB':_vm.inline,'o-icon':!_vm.auto},attrs:{"data-color":"primary"}},[(_vm.icon==='book')?_c('IconBook',{staticStyle:{"position":"relative","top":"-2px"}}):_c('div',{staticClass:"h-color--text",class:'icon-icon_'+_vm.icon,style:(_vm.style)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }